<template lang="pug">
v-container.mb-4
  v-card.rounded-lg.elevation-25.pa-4.pb-12
    v-card-title {{$t('create.chooseTheme.title')}}
    v-card-subtitle 
        | {{$t('create.chooseTheme.subtitle')}} 
        a.text-decoration-underline(target="_top" href="mailto:support@simplymotion.de?subject=Theme anfragen") {{$t('create.chooseTheme.requestBtn')}}
    v-card-text.my-6()
      v-row.px-0.socialElements(v-if="!themes || themes.length == 0 || !selectedTheme")
        v-col.pb-8(cols="12" sm="6" md="3"  v-for='(item, i) in 4' :key='i' )
          v-skeleton-loader.rounded-lg.mx-auto(height="200" type='image')     
      v-row.px-0.socialElements(v-else)
        v-col.pb-8(cols="12" sm="6" md="3" v-for="(theme) in themes" :key="theme.id")
          v-card.rounded-lg.elevation-dense.pb-4(@click="selectTheme(theme)" height="100%" v-ripple="{ center: true }")
            v-card-text.text-center
              v-avatar.elevation-dense(size="90" color="primary")
                v-img(:src="theme.imageUrl" v-if="theme.imageUrl")
            v-card-title.justify-center.text-center {{theme.title}}
              .checkIcon(v-if="selectedTheme && selectedTheme.id === theme.id")
                v-avatar(color="white" size="40" )
                  v-icon(small color="accent") fas fa-check
</template>

<script>
import { mapState, mapMutations } from "vuex";
export default {
  name: "ChooseThemeStep",
  data() {
    return {
      loading: true,
    };
  },
  computed: {
    selectedTheme: {
      get: function () {
        return this.$store.state.create.selectedTheme;
      },
      set: function (newValue) {
        return this.$store.commit("create/set_selected_theme", newValue);
      },
    },
    ...mapMutations("create", {
      setOverlayForElementAtIndex: "set_overlay_for_element_at_index",
    }),
    ...mapState({
      themes: (state) => state.create.themes,
      timelineElements: (state) => state.create.timelineElements,
    }),
  },
  methods: {
    selectTheme(item) {
      this.selectedTheme = item;
      this.updateOverlay(item.overlay, true);
    },
    updateOverlay(overlay, replace = false) {
      this.timelineElements.map((_, index) => {
        // this.setOverlayForElementAtIndex({ index, overlay, replace });
        this.$store.commit("create/set_overlay_for_element_at_index", {
          index,
          overlay,
          replace,
        });
      });
    },
  },
};
</script>
<style lang="sass" scoped>
@import "@/assets/style/variables"

.checkIcon
  position: absolute
  left: 0
  z-index: 2
  bottom: -20px
  right: 0
  display: flex
  justify-content: center
  .v-avatar
    box-shadow: $box-shadow-dense
.v-card--active::before, .v-card:focus::before
  opacity: 0
</style>
